import { Injectable } from '@angular/core';
import {
  SendNotificationCallNotAnsweredGQL,
  SendNotificationEventNotAnsweredGQL,
  SendNotificationSevereAlertGQL,
  SendNotificationThreateningAlertGQL,
} from '../../../generated/graphql';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(
    private eventNotAnsweredService: SendNotificationEventNotAnsweredGQL,
    private callNotAnsweredService: SendNotificationCallNotAnsweredGQL,
    private callNotAnsweredSevereService: SendNotificationSevereAlertGQL,
    private callNotAnsweredThreateningService: SendNotificationThreateningAlertGQL
  ) {}

  callNotAnsweredSevere(id: number) {
    return this.callNotAnsweredSevereService.fetch({ id });
  }

  callNotAnsweredThreatening(id: number) {
    return this.callNotAnsweredThreateningService.fetch({ id });
  }
  
  eventNotAnswered(id: number) {
    return this.eventNotAnsweredService.fetch({ id });
  }

  callNotAnswered(id: number) {
    return this.callNotAnsweredService.fetch({ id });
  }
}
